import {Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React from 'react';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import getMe from '../../../graphql/auth/getMe';
import anyLoading from '../../../utils/anyLoading';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import {checkIsAdmin} from '../../../utils/checkIsAdmin';
import {GroupMemberListContent} from '../GroupMemberList/GroupMemberList';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    results: {
        marginTop: theme.spacing(3)
    }
}));

const MyGroupMembers = () => {
    const classes = useStyles();
    const meData = getMe();
    const loadingData = anyLoading(meData);
    const title = 'My Group Members';

    const isAdmin = checkIsAdmin();

    return (
        <React.Fragment>
            <LoadingOverlay loading={loadingData.loading}>
                {meData.data && meData.data.me && (

                    <Page className={classes.root} title={title}>
                        <PageHeader section="groups" title={title}/>
                        <GroupMemberListContent isAdmin={isAdmin} canEdit={false} myGroupMembers={true} setSelectedMember={isAdmin ? undefined : (dummy: any) => console.log('group member click noop') }/>
                    </Page>
                )}
            </LoadingOverlay>
        </React.Fragment>
    );
};

export default MyGroupMembers;
